import {
  DO_ENVIO_SMS,
  DO_CONSULTA,
  DO_IS_LOADING
} from "@/config/constants/action-types";
import { getParameterByName } from "@/utils";

export default {
  methods: {
    getURLQR() {
      /** Url del motor actual */
      const url = new URL(location.href);
      url.hash = `/ofertaCuenta?hash=${window.hash}`;
      /** URL final para redirección */
      return url.href;
    },
    openModalSMS() {
      this.showModal = true;
    },
    sendSMS(mensaje) {
      this.$store.dispatch(DO_ENVIO_SMS, mensaje);
      this.showModal = false;
    }
  },
  created() {
    //Busco parametro
    if (getParameterByName("hash")) {
      this.$store.dispatch(DO_IS_LOADING, true);
      let hash = {
        hash: getParameterByName("hash")
      };
      this.$store.dispatch(DO_CONSULTA, hash);
    }
  }
};
